import { TEXT_FIELD } from '../type_name'
import { VSpacer } from 'vuetify/lib'
export default {
    name: TEXT_FIELD,
    props: {
        field: {
            type: Object,
        },
        value: {
            type: Object
        }
    },
    methods: {
        // 生成 VSpacer
        setVSpacer(h) {
            if (this.vSpacer) {
                return this.vSpacer
            }
            return this.vSpacer = h(VSpacer)
        }
    },
    render(h) {
        const { label, key, valueRender, default_value = '-', render } = this.field
        let value = default_value
        if (render) {
            value = render({h, field: this.field, target:this.value })
        } else if (valueRender) {
            value = valueRender({field:this.field, value:this.value})
        } else {
            value = [null, undefined, null].includes(this.value[key]) ? default_value : this.value[key]
        } 
        return h('div', {
            style: {
                display: 'flex',
                width: '100%'
            }
        }, [
            h('span', {
                style:{
                    'white-space':'nowrap',
                    'margin-right': '10px'
                }
            }, label),
            this.setVSpacer(h),
            h('span', {}, [value])
        ])
    }
}